/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  box-sizing: border-box;
  display: block;
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--1);
  color: var(--calcite-color-text-2);
}

:host([open]) {
  border-width: 0px;
  border-block-end-width: 1px;
  border-style: solid;
  border-block-end-color: var(--calcite-color-border-3);
}
:host([open]) .toggle {
  color: var(--calcite-color-text-1);
}
:host([open]) .toggle:hover {
  color: var(--calcite-color-text-1);
}
:host([open]) .chevron-icon {
  color: var(--calcite-color-text-3);
}
:host([open]) .chevron-icon:hover {
  color: var(--calcite-color-text-1);
}

:host(:last-child) {
  border-block-end-width: 0px;
}

.toggle {
  inline-size: 100%;
  border-width: 0px;
  background-color: transparent;
  font-family: var(--calcite-font-family);
  gap: var(--calcite-spacing-md);
  color: var(--calcite-color-text-2);
  font-weight: var(--calcite-font-weight-normal);
}
.toggle:hover {
  color: var(--calcite-color-text-1);
}

.toggle--switch,
.section-header {
  margin-inline: 0px;
  margin-block: 0.25rem;
  display: flex;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  padding-inline: 0px;
  padding-block: 0.5rem;
  font-size: var(--calcite-font-size--1);
  outline-color: transparent;
}
.toggle--switch:focus,
.section-header:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.toggle--switch:hover,
.section-header:hover {
  color: var(--calcite-color-text-1);
}

.section-header__text {
  margin-block: 0px;
  flex: 1 1 auto;
  text-align: initial;
  word-wrap: anywhere;
}

.toggle-container {
  position: relative;
  display: flex;
  align-items: center;
  background-color: transparent;
  word-break: break-word;
}
.toggle-container .toggle--switch__content {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
}
.toggle-container .icon--end,
.toggle-container .icon--start,
.toggle-container .chevron-icon {
  display: flex;
  align-items: center;
  color: var(--calcite-color-text-3);
}
.toggle-container .icon--end:hover,
.toggle-container .icon--start:hover,
.toggle-container .chevron-icon:hover {
  color: var(--calcite-color-text-1);
}

.status-icon {
  display: flex;
  align-items: center;
}

.status-icon.valid {
  color: var(--calcite-color-status-success);
}

.status-icon.invalid {
  color: var(--calcite-color-status-danger);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}